import React from "react";
import {Modal} from "@mui/material";
import styled from "styled-components";
import {useTranslation} from "react-i18next";
import {Button} from "../../../../../../common/button";
import {Text} from "../../../../../../common/text";
import Box from "@mui/material/Box";
export const ModalConfirmStatus = ({...props})=>{
    const {t} = useTranslation()
    return(
        <Modal
            open={props?.open}
        >
            <Box style={{display:'flex', justifyContent:'center', alignItems:'center', height: '100vh'}}>
                <StyleModalConfirmStatus>
                    <Text fontSize={20} fontWeight={600}>{t('stop_active_message_confirm_order')}</Text>
                    <div className='modal-confirm-message_label'>
                        <Text>{t('stop_active_message_confirm_order_label')}</Text>
                    </div>
                    <div className='modal-confirm-message_action'>
                        <Button onClick={props?.onCancel} appearance={'ghost'} className='modal-confirm-message_button'>{t('cancel-order')}</Button>
                        <Button onClick={props?.onConfirm} style={{marginLeft: 8}} appearance={'primary'} className='modal-confirm-message_button'>{t('confirm')}</Button>
                    </div>
                </StyleModalConfirmStatus>
            </Box>
        </Modal>
    )
}

const StyleModalConfirmStatus = styled.div`
  width: 480px;
  padding: 24px;
  background-color: #ffffff;
  border-radius: 8px;
  .modal-confirm-message{
    &_label{
      margin: 24px 0 32px 0;
    }
    &_action{
      text-align: right;
    }
    &_button{
      width: 110px;
      height: 32px;
      line-height: 0;
    }
  }

`